/* eslint-disable react/no-danger */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-no-comment-textnodes */

import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import {
  BlockCinema,
  Carousel,
  Footer,
  NamedHeader,
  PageIntroKnaifel,
  QuoteCinema,
  SidesKnaifel,
  Spacer,
  SubTitle,
  Text,
  TypographyWrapper,
} from "../../../lib";

export const NBSP = () => <span style={{ opacity: 0 }}>[</span>;

const SourceText = styled(Text)`
  font-style: italic;
  text-align: right;
`;

const Image = styled.img`
  width: 100%;
`;

const QuoteCinemaText = styled(Text)`
  text-transform: lowercase;
`;

const { PUBLIC_URL } = process.env;

const Cipher: React.FC = () => (
  <TypographyWrapper>
    <NamedHeader name="время" />

    <PageIntroKnaifel author="knaifel" name="cipher" />

    <Spacer size={8} />

    <Carousel
      autoHeight
      slides={[{ url: `${PUBLIC_URL}/assets/images/knaifel/cipher/top.jpg` }]}
    />

    <Spacer half size={10} />

    <SidesKnaifel hideRight="source">
      <BlockCinema>
        <SubTitle lowercase={false}>БЕРЛИН</SubTitle>
        <QuoteCinema>
          <SubTitle>свежая кровь</SubTitle>
          <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
          <>
            Ночное время, звонок от Арво Пярта: «Таня, я сейчас на совещании
            комитета по культурному обмену (Немецкая служба академических
            обменов DAAD. – примеч. авт.), тут только что рекомендовали Шуру по
            музыкальной линии на следующий год». Потом Арво рассказывал, как
            побежал в ближайший магазин и купил диски Шурика для тех, кто может
            быть плохо представлял, кто такой Кнайфель.
          </>
          <Spacer half size={4} />
          <>
            Это 1992 год. Берлин, который в тот момент не так давно объединился,
            должен был восстанавливать свою кровеносную систему. Они понимали,
            что одно из этих средств – свежая кровь из других стран, и охотно
            принимали тех, кто хоть как-то отличился. В тот момент подобный год
            завершался у Гии Канчели, да и сам Арво был когда-то таким же гостем
            DAAD: «Вы понимаете, Таня, это полное обеспечение на год, можно жить
            и работать, он получит новые контакты, новые возможности
            исполнения».
          </>

          <Spacer half size={4} />
          <Image
            alt="Александр Кнайфель"
            src={`${PUBLIC_URL}/assets/images/knaifel/cipher/2.jpg`}
          />
          <Spacer half size={4} />

          <>
            Так оно и было. И в конце этого года был очень красивый концерт в
            Шаушпильхаус в Берлине. Это было подтверждение того, что он смог
            сделать, и было понятно, что последствия не заставят себя долго
            ждать. Началось живое время, он получил контакты, пошли вызовы, его
            стали повсюду исполнять.
          </>
          <Spacer half size={4} />
          <>
            Через год вернулись в Петербург. Мы в вообще в Берлине плотно
            никогда не жили, приезжали только на его исполнения.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
      </BlockCinema>

      <Spacer half size={10} />

      <BlockCinema>
        <SubTitle lowercase={false}>ВАШИНГТОН</SubTitle>
        <SubTitle>великое спасибо за великую партитуру</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          В нашей квартире есть портрет – Слава [Ростропович] мне подарил, – где
          он очень юный. Он уже был в изгнании и писал мне: «Слушай, тебя
          заберут на Соловки, приходили люди, я знаю, что мой портрет у тебя
          висит в кабинете, тебя могут..». А потом я стал писать «Восьмую
          главу», и как! Это была зима 1992 года. Вдруг раздается звонок, его
          голос: «Я в Петербурге, никто не знает, инкогнито, очень хочу к тебе
          сейчас приехать». И приезжает, и я ему показываю, я нахожусь в
          эпицентре этого сочинения. Невероятно. Потом мы уехали в Берлин, и уже
          из Берлина я ему посылаю готовую партитуру в Вашингтон. Получаю от
          него факс: «Великое спасибо за великую партитуру. От Славы».
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cipher/2a.jpg`}
        />

        <Spacer half size={4} />
        <SubTitle>«восьмая глава»</SubTitle>
        <>
          И потом была премьера. Вашингтонский собор, его строили почти сто лет.
          Шесть тысяч человек, самый большой храм в мире. Шесть тысяч, но каких!
          Начиная от представителей Белого дома, миллионеров, вплоть до хиппи в
          драных штанах, которые сидели на полу, потому что уже не было ни
          стульев, ничего. А акустика… Писала фирма Teldec. Вишневская вопила:
          «Вы два идиота! Вы себе представляете! Они же вас изничтожат, любой
          чик-чирик..» А там очень тихая музыка. И существует документальная
          запись, как будто бы там вообще ни одного человека нет.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>

        <Spacer half size={4} />

        <QuoteCinema>
          <SubTitle>пространственная музыка</SubTitle>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            В кнайфелевской музыке пространство является одним из основных
            параметров текста. В «Восьмой главе» четыре хора стоят в виде креста
            по краям храма: впереди – детский, справа – мужской, слева – женский
            и сзади смешанный, а в центре – виолончелист.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[A—B]</Link>
            </sub>
          </>
          <Spacer half size={4} />
        </QuoteCinema>

        <QuoteCinema right={false}>
          <QuoteCinemaText>александр кнайфель:</QuoteCinemaText>
          <span style={{ fontStyle: "italic" }}>
            {
              "<...> пространство «входит в комплект» сочинения – возникает живое."
            }
          </span>
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[B—I]</Link>
          </sub>
          <Spacer half size={4} />
        </QuoteCinema>

        <QuoteCinema>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            <a
              href="https://youtu.be/AH2JqTlhBJ8"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              «Восьмая глава»
            </a>{" "}
            – это «Песнь песней», то есть гимн любви, которую он сразу задумал
            как подношение Ростроповичу.
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/karavajchuk/source">[C—C]</Link>
            </sub>
          </>
          <Spacer half size={4} />
        </QuoteCinema>
      </BlockCinema>

      <Spacer half size={10} />

      <BlockCinema>
        <SubTitle>нежнее нежного</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Меня сражало это всегда: «невозможное» сочетание невероятной силы,
          энергии с внутренним трепетом и всепоглощающим вниманием. Его сила – в
          его нежности, нежности, которая исходит из самого сокровенного. Это
          абсолютная стихия Славы – нежнее нежного, вы можете слышать это в его
          запредельных pianissimo, в неизбывной трепетности звучания, когда он
          дарует себя всего, словно человеческим голосом.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[D—C]</Link>
          </sub>
        </>
        <SourceText>
          из дневника:
          <br />
          30.12.92
          <br />
          Моей музыке необходимы крупные, незаурядные, яркие, мощные
          исполнители, ибо она вся на них (и только на них!) изначально
          сориентирована
        </SourceText>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cipher/2b.jpg`}
        />
        <Spacer half size={4} />
      </BlockCinema>
    </SidesKnaifel>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>
        ФРАНКФУРТ. МЕЖДУ КЕЙДЖЕМ И ШТОКХАУЗЕНОМ
      </SubTitle>
      <SubTitle>бла-бла, вау-вау-вау</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Это всё лекала, знаете? «Было трудно, было то-то, не давали работать..».
        В Москве это действительно было, а у нас в Петербурге я с этим не
        сталкивался. За рубеж не пускали, но опять-таки я не так уж страдал от
        этого.
      </>

      <>
        А с другой стороны, когда в 1992 году начинался Франкфуртский фестиваль,
        где был я, Кейдж и Штокхаузен – эти столпы современной музыки… Там
        выбрали мои вещи, невероятно сложные для исполнения, в том числе никогда
        и нигде до этого не звучавшие: «Жанна» [1978] и «Ника» [1984].
      </>

      <>
        Для «Жанны» огромный зал Alte Oper взяли и полностью перемонтировали,
        сделали четыре трибуны, на три дня закрыли вообще, чего не было никогда
        в истории. Репетировали, пригласили меня. Я хожу на эти репетиции,
        дирижер ничего не понимает, а считается самым лучшим. Сплошные интервью,
        все время корреспонденты, вся эта мишура, шуму полно. И я тогда подумал:
        «Елки-палки, ничего же там вообще нет. Ничего. Не то что блюда, гарнира
        нет».
      </>
      <Spacer half size={4} />
      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/3.jpg`}
      />

      <>
        А тут тебя наоборот не исполняют. Вот тогда-то я и понял: фактически это
        явления одного порядка. Это все бла-бла, вау-вау-вау.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—A]</Link>
        </sub>
      </>

      <Spacer half size={4} />

      <QuoteCinema>
        <SubTitle>не по духу</SubTitle>
        <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
        <>
          Нельзя обвинить иностранных музыкантов в небрежности, они очень точны.
          Как раз если играет западный оркестр, можно быть уверенным, что все
          будет так, как написано в нотах. Но, вы понимаете, что-то было не по
          духу, не все отзывается. Все-таки наша культура, и люди, которые в ней
          выросли, как на почве родной.
        </>
        <Spacer half size={4} />
        <>
          Я бы так сказала, избегая широких пафосов, что он по-своему патриот.
          Он об этом не говорил, но чувствовал себя укорененным в культуре.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—B]</Link>
          </sub>
        </>
      </QuoteCinema>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>ПЕТЕРБУРГ</SubTitle>
      <SubTitle>петербуржец по национальности</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Разговаривая с Баланчиным в Нью-Йорке, Соломон Волков спросил: «Георгий
        Мелитонович, а кем вы себя чувствуете вообще?» И тут он отчеканил на
        века: «Я по крови – грузин, по культуре и по воспитанию – я русский, а
        по национальности я – петербуржец». И я подписываюсь под этим, только
        вместо грузина надо написать – еврей. И теперь это уже фигурирует везде:
        я петербуржец по национальности.
      </>

      <>
        Это город, в котором дома были позже улиц. И он с самого начала строился
        как град небесный, это же известно. Причем именно по Апокалипсису, как
        там написано: не мерой человеческой, а мерой ангельской. И то, что
        являет собой по-Божьему велению Петербург, невозможно себе до конца
        представить.
      </>

      <>
        Это накладывает отпечаток на все абсолютно, особенно на человека,
        который занимается проблемами чистого искусства как такового. Тот
        инструментарий, те лекала, по которым велось градостроительство, они в
        моей плоти и крови.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—A]</Link>
        </sub>
      </>
      <Spacer half size={4} />
      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/4.jpg`}
      />

      <SourceText>
        из дневника:
        <br />
        08.10.03
        <br />
        {/* ------------------------------------------------------------------ */}
        Быть может, мое исконное стремление к единственности, тоже от города –
        явления единственного!
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[E—I]</Link>
        </sub>
      </SourceText>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>КРЕЩЕНИЕ</SubTitle>
      <SubTitle>«не могу жить сиротой!»</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Я уже рисовал
        <NBSP />
        <a
          href="https://www.youtube.com/watch?v=dP6JzFFcuNo&t=1s"
          style={{
            borderBottom: "1px solid #ccc",
          }}
        >
          «Облаченную в солнце»
        </a>
        , это было накануне нового 1996 года, а второго утром я встаю и
        чувствую, что в грудине булыжник. Меня увезли в больницу с инфарктом
        прямо в реанимацию.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—C]</Link>
        </sub>
      </>

      <Spacer half size={4} />
      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/5.jpg`}
      />
      <Spacer half size={4} />

      <>
        Должен сказать, прости Господи, что всем бы пожелал инфаркта! Это такая
        чистота и новизна восприятия после, нулевая чистота. Помню, в конце
        апреля я лежал на диване и внятно почувствовал: «Я больше не могу жить
        сиротой!» Простая и пронзительная мысль.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—C]</Link>
        </sub>
      </>

      <SourceText>
        из дневника:
        <br />
        20.01.96
        <br />
        {/* ------------------------------------------------------------------ */}
        О Боже! М.б. без подобного вообще не ощутить дыхание этой Глубины?!?!...
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[E—I]</Link>
        </sub>
      </SourceText>

      <Spacer half size={4} />
      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/6.jpg`}
      />
      <Spacer half size={4} />

      <>
        Я позвонил Сереже [Сергей Вакуленко – поэт, музыкант и мыслитель.
        Близкий друг Кнайфеля], и он все организовал. Крещение произошло второго
        мая 1996 года. И меня совершенно покорило, что моя матушка, ни сном ни
        духом, не готовая ни к чему, просто из любви ко мне пришла и со мной
        крестилась.
      </>

      <>
        А вслед за этим в 1996 году произошло венчание. Я просил Таню принять
        крещение и сказал, что хочу, чтобы
        <NBSP />
        <span
          style={{
            fontStyle: "italic",
          }}
        >
          там
        </span>
        <NBSP /> мы тоже были вместе.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—C]</Link>
        </sub>
      </>

      <Spacer half size={4} />

      <QuoteCinema>
        <SubTitle>облегченным и просветленным</SubTitle>
        <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
        <>
          У него же был инфаркт, и когда грохнула беда, он искал поддержки в
          чем-то, и нашел ее в Боге, став искренне верующим человеком.
        </>
        <Spacer half size={4} />
        <>
          Обращение к Богу поддерживало его последние лет двадцать. Он
          невероятно нуждался в этом, из церкви уходил облегченным и
          просветленным.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—B]</Link>
          </sub>
        </>
        <Spacer half size={4} />
      </QuoteCinema>

      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/7.jpg`}
      />
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>«не бойся, господи, – я с тобой!»</SubTitle>
      <SubTitle>сказки</SubTitle>
      <>татьяна мелентьева:</>
      <>
        Искренняя вера, к которой он пришел во взрослом возрасте – это
        удивительно. В нем самом такая ребячливость – у нас целый отдел
        книг-сказок, он любил любые сказки как жанр. В его натуре что-то такое,
        что переплавляется над рацио.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—B]</Link>
        </sub>
      </>

      <Spacer half size={4} />
      <Carousel
        autoHeight
        slides={[
          { url: `${PUBLIC_URL}/assets/images/knaifel/cipher/8.jpg` },
          { url: `${PUBLIC_URL}/assets/images/knaifel/cipher/9.jpg` },
        ]}
      />
      <QuoteCinema dots={false}>
        <>голова – в небе, ноги – на земле!</>
        <Spacer half size={4} />
        <SourceText>
          из дневника:
          <br />
          26.02.05
          <br />
          В<NBSP />
          <a
            href="https://www.youtube.com/watch?v=rRKZd8UwXTg"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            сказках
          </a>
          <NBSP />
          собрана , сквозит вся правда нашего мира
          <br />
          Пребывание, постоянная устремленность в зоне “возможное -
          невозможное”...
          <br />
          Нескончаемая россыпь Божьих чудес в привычных буднях!
          <br />
          Непреложно: голова – в небе, ноги – на земле!
        </SourceText>
      </QuoteCinema>
      <Spacer half size={4} />
      <Image
        alt="Александр Кнайфель"
        src={`${PUBLIC_URL}/assets/images/knaifel/cipher/10.jpg`}
      />
      <Spacer half size={4} />
      <SubTitle>опыт, который я могу вычитать, – это не мой путь</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Дитя при мне как-то беспримерно точно определило: «Не бойся, Господи, –
        я с тобой!...» Так сложилось, что остался ребенком на всю жизнь, но, тем
        не менее, шагал ступеньку за ступенькой, я всегда понимал, что опыт,
        который я могу вычитать или услышать, – это не мой путь. Я своей шкурой
        должен все протащить. И я протащил насколько мог. Весь Старый Завет,
        потом вдруг в определенный момент оказалось, что я уже на пороге Нового.
        И невозможно жить сиротой. Это такое понятное, такое щемящее чувство.
        Рано или поздно с меньшей или большей остротой эта проблема все равно
        возникает. Потому что мы с этим рождены.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[A—A]</Link>
        </sub>
      </>

      <Spacer half size={4} />

      <QuoteCinema>
        <SubTitle>момент перерождения</SubTitle>
        <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
        <>
          Видно по его сочинениям, когда он стал обращаться к духовным текстам.
          Несмотря на то, что он пишет религиозную духовную музыку уже с начала
          90-х, крестится лишь в 1996 году, когда уже были написаны и «Восьмая
          глава», и «Свете тихий», и ряд духовных опусов для Ростроповича. Это
          его сознательный шаг, когда он уже прошел этот путь, узнал его, и
          принял. Можно сказать, что это элементы его личного воцерковления,
          перед тем, как самому принять крещение
        </>
        <Spacer half size={4} />
        <>
          Но очень важно, что Кнайфель никогда не был ортодоксом. Умение быть в
          очень широком контексте – видеть, чувствовать, создавать, слышать,
          понимать, такая открытость при совершенно уже четких внутренних
          позициях.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—C]</Link>
          </sub>
        </>
      </QuoteCinema>

      <Spacer half size={4} />

      <SubTitle>медленные гиганты</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Вы знаете, я пятнадцать лет находился в другом временном измерении.
        Прошел старозаветный путь, освоил многие музыкальные пространства: жизнь
        души в «Жанне», детство в<NBSP />
        <a
          href="https://youtu.be/7uBBZ0sKPN8"
          style={{
            borderBottom: "1px solid #ccc",
          }}
        >
          «Глупой лошади»
        </a>
        , смерть в<NBSP />
        <a
          href="https://youtu.be/_NqERSciTP4"
          style={{
            borderBottom: "1px solid #ccc",
          }}
        >
          «Agnus Dei»
        </a>
        , любовь в «Сквозь радугу невольных слез», континуум мироздания и космос
        души в «Нике»… (Все они звучали в моей ретроспективе на Франкфуртском
        фестивале в 1992 году.) Это были медленные гиганты. А тут вдруг
        почувствовал: грядет эон Святого Духа. И не заметил, как побежал. Или
        полетел. Будто другим человеком стал.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—J]</Link>
        </sub>
      </>

      <Spacer half size={4} />

      <QuoteCinema>
        <SubTitle>этапы</SubTitle>
        <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
        <>
          Путь от «Ники» к концу 90-х годов – это время, которые он сам называл
          «Время тихих гигантов». Большие сочинения, медленные, тянущиеся,
          плывущие. Это
          <NBSP />
          <a
            href="https://youtu.be/6OQAI7Qjzeg"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Ника»
          </a>
          , это
          <NBSP />
          <a
            href="https://youtu.be/_NqERSciTP4"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Agnus Dei»
          </a>
          , это
          <NBSP />
          <a
            href="https://youtu.be/AH2JqTlhBJ8"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Восьмая глава»
          </a>
          . Ряд его медитативных опусов, которые стали прочно ассоциироваться со
          стилем Кнайфеля.
        </>
        <Spacer half size={4} />
        <>
          А в конце 90-х начинается новый этап. Это
          <NBSP />
          <a
            href="https://youtu.be/nKilJ6xhdHU"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Алиса в стране чудес»
          </a>
          , поставленная в Королевской опере в Нидерландах. Там он поднимается
          еще выше, там уже слово, число, жест. И жест у него тоже становится
          частью партитуры. И предметы, и световые объекты, звучащие и не
          звучащие, все они становятся вписанными в сам текст.
        </>
        <Spacer half size={2} />
        <>
          Дальше – уже стиль позднего Кнайфеля. В 2010-е годы для него очень
          важным в музыке становится стремительность, полетность, очень быстрые
          темпы, несущиеся фигурации – то, что он воплощает в своих сказочных
          сочинениях.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/karavajchuk/source">[C—C]</Link>
          </sub>
        </>
      </QuoteCinema>

      <Spacer half size={4} />

      <SubTitle>новая письменность</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Я очень доволен тем, что весь мой достаточно емкий объем того, что
        удалось сделать, занимает всего четыре машинописные странички [каталог
        сочинений]. У меня это очень просто называется: «Проявленный мир». Но я
        получал огромное количество записей, которые меня уничтожали, я просто
        не знал, что делать. И в какой-то момент понял, что я виноват в этом
        сам. Это был 2014 год. С этого момента за девять лет я перелопатил
        огромное количество партитур, особенно ранних, я их все переписал.
        Музыка осталась та же самая, но теперь она записана немножко непривычно,
        зато исполнителя приближает к тому, что должно быть.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—A]</Link>
        </sub>
      </>
      <SourceText>
        из дневника:
        <br />
        17.12.12 (с днем рождения, мамочка!)
        <br />
        Все мои редакции прежнего – чтобы любовь моя стала совершеннее!
      </SourceText>
      <Spacer half size={4} />
      <>
        Надо всегда трезветь сознанием, что любая названность всегда таит в себе
        ловушку. Бог вдохнул в человека все знание, какое только возможно. Но
        знание-то «упразднится». Я это с рождения чувствую. Поэтому всегда в
        гостевом ощущении, ощущении чужого. Чужого принципиально. В ужасе от
        всех учебных заведений. В каждом человеке ведь вся полнота знания. Но
        она требует невероятной внимательности и трепетного смирения. Это та
        нежность и слабость, которые могут превозмочь решительно всё. А мы как
        бы все знаем, самые пронзительные вещи настолько очевидны, что скользим
        мимо, не успевая встретиться.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—L]</Link>
        </sub>
      </>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>ВНИМАНИЕ</SubTitle>
      <SubTitle>изнуряющее внимание к моменту</SubTitle>
      <>
        В любом обществе человек остается Божьим созданием. Я думаю, это
        главное. В основе всего лежит изнуряющее внимание к моменту. Это почти
        непосильная работа. Даже если вы сумели в какой-то момент быть в полноте
        внимания, не упустили благодаря этому чего-то, и даже в творчестве это
        отразилось, этот факт вам ничего не гарантирует. Вы дальше должны так же
        точно изнурительно работать и жить с этим вниманием. Содеянное не дает
        вам никакой гарантии ни на что. В один момент случится, а в следующий
        момент вы точно так же отступитесь.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—A]</Link>
        </sub>
      </>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>ДАР</SubTitle>
      <SubTitle>не «сочинять» музыку, а возделывать жизнь</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Нет изолированного знания или умения, оно не изолированное, это единое
        святое возделывание жизни, которую каждый возделывает как может. С Валей
        [Сильвестровым] мы говорили, что «сочинить» музыку – это фальшь. Чтобы
        пребывать в разных аспектах музыки, нужно касаться самой жизни.
      </>
      <Spacer half size={4} />
      <Carousel
        autoHeight
        slides={[
          { url: `${PUBLIC_URL}/assets/images/knaifel/cipher/11.jpg` },
          { url: `${PUBLIC_URL}/assets/images/knaifel/cipher/13.jpg` },
        ]}
      />
      <Spacer half size={4} />
      <SubTitle>быть собой во всей полноте</SubTitle>
      <>
        Все мои произведения живы, некоторые живут длительностью в 30-40 секунд,
        некоторые – три часа. Нет разницы, это тоже очень важно. У Господа
        вообще нет этих человеческих понятий: лучше-хуже. Либо получилось, либо
        нет. В конечном итоге все определяет твой ориентир. Не хочу его называть
        высотой, светом, чем-либо – это необходимость быть собой во всей
        полноте, не такой даже, как ты себе представляешь, а той, какая есть на
        самом деле, которая хоть раз в жизни тебе открывается.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[B—C]</Link>
        </sub>
      </>
      <SourceText>
        из дневника:
        <br />
        06.10.02
        <br />
        У каждого человека есть территория, на которой ему нет равных (!)
        <br />
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[E—I]</Link>
        </sub>
      </SourceText>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>ТИШИНА</SubTitle>
      <SubTitle>эффект поворота иглы</SubTitle>
      <Text>александр кнайфель:</Text>
      <>
        Что значит пауза? Пауз вообще нету. И если мы с вами помолчим, то, что
        называется паузой, и будет на самом деле музыка. Как-то один из
        художников замечательно сказал: «Эффект поворота иглы». Вы смотрите на
        иголку, она так потихонечку поворачивается. И эта иголка превращается в
        точку. То есть вся длина, все пространство превращается в ничто как бы.
        И отчасти что-то подобное я взыскую в музыке.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[A—A]</Link>
        </sub>
      </>
      <SourceText>
        из дневника:
        <br />
        17.06.13
        <br />
        Тишина – вместилище всех звучаний (как белый свет – вместилище всех
        цветов).
        <br />
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[E—I]</Link>
        </sub>
      </SourceText>
    </BlockCinema>

    <Spacer half size={10} />

    <BlockCinema>
      <SubTitle lowercase={false}>ПРОЗРАЧНОСТЬ</SubTitle>
      <SubTitle>белоснежность</SubTitle>
      <Text>александр кнайфель:</Text>
      <>Белоснежность – это мое личное. </>
      <Spacer half size={4} />
      <SubTitle>прозрачность дарует белизну</SubTitle>
      <>
        Мой дядя был выдающимся ученым-изобретателем, и он, когда я был совсем
        еще мальчишечкой, поведал мне нечто, поразившее меня на всю жизнь: «Вот
        видишь, снег лежит, он весь белый, белоснежный. А ты знает, что каждая
        снежинка, из которой состоит этот снег, отдельно взятая совершенно
        прозрачная? У нее нет никакого цвета». И меня это очень поразило. Тут,
        по-моему, вообще основополагающая вещь всего нашего бытия. Когда все на
        свете прозрачно и, главное, мы прозрачны, нам даруется белизна. А белый
        цвет – это полнота жизни, это полнота всех цветов. Черный цвет – это не
        цвет, а отсутствие цвета. Так же это отсутствие и света. Прозрачность и
        белизна – это понятия, которые все изначально определяют в нашей жизни.
      </>
      <>
        Меня на всю жизнь ошеломило это понимание. За городом особенно: смотришь
        – все белое, все белоснежное – и понимаешь, что в основе своей это все
        прозрачно, а не бело. То есть белый цвет нуждается, как и, собственно,
        все на свете, в самой большей степени этой прозрачности.
        <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
          <Link to="/karavajchuk/source">[C—A]</Link>
        </sub>
      </>
    </BlockCinema>

    <Spacer size={80} />

    <Footer />
  </TypographyWrapper>
);

export default Cipher;
